






































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import { Loading } from '@/types/_'
import { maskCPFCNPJ, timeout } from '@/utils/common'
import ModalNovoContrato from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalNovoContrato.vue'

@Component({
  components: {
    ModalNovoContrato,
  },
})
export default class ViewBackofficeContratos extends Vue {
  tblLoading: boolean = false
  prsLoading: boolean = false
  novoContratoLoad: boolean = false
  loading: Loading = {
    status: false,
    text: '',
  }

  debounce = _.debounce(async (search: string) => {
    await this.getBackofficeContratosStore.getAllPrestadoresRecebimento({ limite: 20, filtro: search })
    this.tableLoading = false
  }, 700)

  get tableLoading() {
    return this.tblLoading
  }

  set tableLoading(value: boolean) {
    this.tblLoading = value
  }

  get prestadorLoading() {
    return this.prsLoading
  }

  set prestadorLoading(value: boolean) {
    this.prsLoading = value
  }

  get novoContratoLoading() {
    return this.novoContratoLoad
  }

  set novoContratoLoading(value: boolean) {
    this.novoContratoLoad = value
  }

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get prestador() {
    return this.getBackofficeContratosStore.prestador
  }

  set prestador(value: any) {
    this.getBackofficeContratosStore.setPrestador(value || { id: '', nome: '', documento: '' })
  }

  get prestadores() {
    return this.getBackofficeContratosStore.prestadoresRecebimento
  }

  get prestadoresSearch() {
    return this.getBackofficeContratosStore.prestadoresSearch
  }

  set prestadoresSearch(value: string) {
    this.getBackofficeContratosStore.setPrestadoresSearch(value)
  }

  get prestadoresSearchCache() {
    return this.getBackofficeContratosStore.prestadoresSearchCache
  }

  set prestadoresSearchCache(value: string) {
    this.getBackofficeContratosStore.setPrestadoresSearchCache(value)
  }

  get contratos() {
    return this.getBackofficeContratosStore.contratos
  }

  get prestadoresTableHeader() {
    return this.getBackofficeContratosStore.prestadoresTableHeader
  }

  get contratosTableHeader() {
    return this.getBackofficeContratosStore.contratosTableHeader
  }

  maskCnpj(value: any) {
    return maskCPFCNPJ(value)
  }

  formatStatus(str: string) {
    switch (str.toLowerCase()) {
      case 'ativo':
        return { text: 'Ativo', color: 'success' }
      case 'inativo':
        return { text: 'Inativo', color: 'error' }
      default:
        return { text: 'Pendente', color: 'warning' }
    }
  }

  get loadingRequest() {
    return this.loading
  }

  set loadingRequest(value: Loading) {
    this.loading = value
  }

  get getRequestMessage() {
    return this.getBackofficeContratosStore.requestMessage
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest.status = status
    this.loadingRequest.text = text
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  async openNovoContrato() {
    this.novoContratoLoading = true
    await this.getBackofficeContratosStore.getAllFontesPagadoras()
    this.getBackofficeContratosStore.setShowModalNovoContrato(true)
    this.novoContratoLoading = false
  }

  async getContratos(prestadorId: any) {
    const id = typeof prestadorId === 'string' ? prestadorId : (prestadorId.userId || prestadorId.id)
    
    if (!id) return
    
    this.tableLoading = true
    await this.getBackofficeContratosStore.getAllContratos(id)
    this.tableLoading = false
  }

  async onSelectPrestador(value: any) {
    await this.getContratos(value)
    this.prestador = value

    if (this.prestadoresSearchCache) {
      this.$nextTick(() => {
        this.prestadoresSearch = this.prestadoresSearchCache
      })
    }
  }

  visualizarContrato(id: string) {
    this.$router.push(`/backoffice/contratos/${id}`)
  }

  clearContratos() {
    this.getBackofficeContratosStore.setContratos([])
    this.getBackofficeContratosStore.setPrestador({ id: '', nome: '', documento: '' })
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.debounce('')
    await timeout(1000)
    this.clearLoadingRequest()
  }

  restorePrestadoresSearch() {
    const search = this.prestadoresSearch || this.prestadoresSearchCache || ''

    if (!search) return

    this.prestadoresSearchCache = search
    this.prestadoresSearch = search
  }

  async mounted() {
    this.restorePrestadoresSearch()

    // Se há dados em cache (usuário voltou da página de visualização), restaura o prestador
    if (this.prestador && this.prestador.id && this.contratos.length > 0) {
      return
    }
    await this.init()
  }

  @Watch('prestadoresSearch')
  async onPrestadoresSearch(value) {
    if(!value) return

    if (value && value.trim()) {
      this.prestadoresSearchCache = value
    }

    const filtro = value.trim()
    
    if (filtro.length < 3) {
      if (!filtro) {
        this.prestadorLoading = true
        await this.getBackofficeContratosStore.getAllPrestadoresRecebimento({ limite: 20 })
        this.prestadorLoading = false
      }
      return
    }

    this.prestadorLoading = true
    await this.debounce(filtro)
    this.prestadorLoading = false
  }

  getWindowWidth() {
    const doc: Document = document

    if (doc !== null) {
      const documentWidth = doc.documentElement.clientWidth
      const contratosTable = (doc.querySelector('.contratos-table') as HTMLDivElement)
      contratosTable.style.width = (documentWidth < 576) ? `${documentWidth - 32}px` : '100%'
    }
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
